export const SUPPORTED_LANGUAGES = ["uz", "uz-cyrl", "ru", "en"] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_LABELS: Record<AppLanguage, string> = {
  uz: "O'zbekcha",
  "uz-cyrl": "Ўзбекча",
  ru: "Русский",
  en: "English",
};

export const LANGUAGE_SHORT_LABELS: Record<AppLanguage, string> = {
  uz: "UZ",
  "uz-cyrl": "ЎЗ",
  ru: "RU",
  en: "EN",
};

export const DEFAULT_LANGUAGE: AppLanguage = "uz";
export const LANGUAGE_STORAGE_KEY = "app_language";

export function isSupportedLanguage(value: string): value is AppLanguage {
  return SUPPORTED_LANGUAGES.includes(value as AppLanguage);
}

export function resolveLanguage(value?: string | null): AppLanguage {
  if (!value) {
    return DEFAULT_LANGUAGE;
  }

  const normalizedValue = value.toLowerCase();
  if (isSupportedLanguage(normalizedValue)) {
    return normalizedValue;
  }

  const baseLanguage = normalizedValue.split("-")[0];
  return isSupportedLanguage(baseLanguage) ? baseLanguage : DEFAULT_LANGUAGE;
}
